const defaultTranslations = {
  'actionPopover.close': 'Close',
  'banner.close': 'Close',
  'datagrid.actionsButton': 'Actions',
  'datagrid.columnManager.settings': 'Settings',
  'datagrid.selectAllRows': 'Select all rows',
  'datagrid.selectRow': 'Select row {{rowNumber}}',
  'loadingElement.title': 'Loading...',
  'message.close': 'Close',
  'select.placeholder': 'Select...',
  'sidePanel.close': 'Close',
  'tabGroup.scrollLeft': 'Scroll left',
  'tabGroup.scrollRight': 'Scroll right',
  'tag.remove': 'Remove',
  'toast.close': 'Close',
} as const;

export default defaultTranslations;
export type TranslationKey = keyof typeof defaultTranslations;
